module.exports = __webpack_public_path__ + "media/images/atterra-33f161a15c74bc3cb00e867c47dfbe0a.png";